import React, { useState, useEffect } from 'react';
import { DataGrid, useGridApiRef, GridToolbar, GridToolbarQuickFilter } from '@mui/x-data-grid';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import {
  Button, Modal, Box, Select, ListSubheader, FormControl,
  MenuItem
} from '@mui/material';
import axios from 'axios';
import { baseURL } from '../Constant';
import Campaign from './Campaign';
import { useMsal } from "@azure/msal-react";
import './CampaignsTable.css';

const marketOrTrackList = [
  {
    group: "Market",
    sub_list: [
      "ATCI",
      "EMEA",
      "GM",
      "ATC Global Network",
      "ATCI Song",
      "Cloud",
      "AI",
      "E&IT",
      "I&D",
      "Delivery",
      "BI&HS",
      "Language & Culture Academy",
      "L&TT",
      "LIS",
      "L&TT Ops",
      "LDE NeXT",
    ],
  },
  {
    group: "6 specialized Practices",
    sub_list: [
      "Enterprise Platforms",
      "Cloud First",
      "Data & AI",
      "Security",
      "Infrastructure Engineering",
      "Software & Platform Engineering",
    ],
  },
  {
    group: "5 Technology Industry Practices",
    sub_list: [
      "Communications/Media/Technology",
      "Financial Services",
      "Health/Public Service",
      "Products",
      "Resources",
    ],
  },
];


const CampaignsTable = ({ approvalView, setL2 }) => {

  const [campaigns, setCampaigns] = useState([]);
  const [currCampaign, setCurrCampaign] = useState(null);// this will actually contain an object which is the current rowdata
  const [loggedInEnterpriseId, setLoggedInEnterpriseId] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [modalRecord, setModalRecord] = useState();
  const [sortModelNew, setSortModelNew] = useState([]);
  const [marketEditable, setMarketEditable] = useState(false);
  const [newMarketName, setMarketName] = useState("initial value");

  const fetchApi = approvalView ? `${baseURL}/campaigns` : `${baseURL}/campaignsByUser/${loggedInEnterpriseId}`;

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  useEffect(() => {
    if (activeAccount) {
      setLoggedInEnterpriseId(activeAccount.idTokenClaims.enterpriseID);
    }
  }, [activeAccount]);


  useEffect(() => {
    const fetchCampaignsData = async () => {
      try {
        const response = await axios.get(fetchApi);
        if (approvalView) {
          setCampaigns(response.data.filter((items) => items.status !== 'Saved as Draft'));
        }
        else {
          setCampaigns(response.data);
        }
      } catch (error) {
        console.error('Error fetching campaigns data:', error);
      }
    };
    fetchCampaignsData();
  }, [loggedInEnterpriseId, currCampaign]);

  function convertToDateString(isoDateString) {
    // Create a Date object from the ISO date string
    const date = new Date(isoDateString);

    // Extract the year, month, and day
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');

    // Format and return as yyyy-mm-dd
    return `${day}-${month}-${year}`;
  }

  //Just a visual sugar which displays "Submitted for Review" as "Waiting for Approval"
  const displayHelper = (arr) => {
    const updCamp = arr.length > 0 ? arr.map((item) => {
      if (item.status === 'Submitted for Review') {
        return { ...item, status: "Waiting for Approval" };
      }
      else return item;
    }) : [];
    return updCamp;
  }

  const helperFunc = (rowData) => {
    setCurrCampaign({
      id: rowData.id,
      name: rowData.name,
      requestorId: rowData.requestorId,
      startDate: rowData.startDate,
      endDate: rowData.endDate,
      status: rowData.status,
      type: rowData.type,
      market: rowData.market,
      target_audience: rowData.target_audience,
      people_targeted: rowData.people_targeted,
      fileUrl: rowData.fileUrl
    });
    if (setL2 !== undefined) setL2(rowData.name);
  }

  const handleBackClick = () => {
    setCurrCampaign(null);
    if (setL2 !== undefined) setL2("");
  }

  const buttonGenerator = (rowData) => {
    return <Button style={{ textTransform: 'none' }} variant="text" onClick={() => helperFunc(rowData)}>{approvalView ? 'Review Campaign' : 'View Campaign'}</Button>
  }

  const handleOpen = (record) => {
    setOpenModal(true);
    setModalRecord(record);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleSortModelChange = (newSortModel) => {
    setSortModelNew(newSortModel);
  };

  const handleMNSubmit = async (e, recordId) => {
    e.preventDefault();

    if (!recordId) {
      console.error("No record ID provided!");
      return;
    }
    if (!newMarketName) {
      console.warn("Market name cannot be empty.");
      return;
    }
    else { console.log("newMarketName"); }
    try {
      const response = await axios.put(`${baseURL}/marketInCampaign/${recordId}`, { newMarketName });
      setCampaigns(prevCampaigns =>
        prevCampaigns.map(campaign =>
          campaign.id === recordId
            ? { ...campaign, market: newMarketName }
            : campaign
        )
      );
      alert(response.data?.message);

    } catch (err) {
      console.log(err);
    }

    setOpenModal(false);
    setMarketEditable(false);
    setMarketName("");
  }

  let columns = [
    {
      field: 'serialNumber',
      headerName: <div style={{ paddingLeft: '10px' }}>SI#</div>,
      width: 80, // Set fixed width
      renderCell: (params) => params.api.getSortedRowIds().indexOf(params.id) + 1,
    },
    {
      field: 'name',
      headerName: <div style={{ paddingLeft: '10px' }}>Campaign Name</div>,
      width: 200, // Fixed width
    },
    {
      field: 'submitted_for_review',
      headerName: <div style={{ paddingLeft: '10px' }}>Created On</div>,
      width: 150, // Fixed width
      valueFormatter: (params) => {
        return params ? convertToDateString(params) : "-"; // Check for null or undefined
      },
    },
    {
      field: 'type',
      headerName: <div style={{ paddingLeft: '10px' }}>Campaign Type</div>,
      width: 150, // Fixed width
    },
    {
      field: 'startDate',
      headerName: <div style={{ paddingLeft: '10px' }}>Start Date</div>,
      width: 150, // Fixed width
      valueFormatter: (params) => convertToDateString(params),
    },
    {
      field: 'endDate',
      headerName: <div style={{ paddingLeft: '10px' }}>End Date</div>,
      width: 150, // Fixed width
      valueFormatter: (params) => convertToDateString(params),
    },
    {
      field: 'link',
      headerName: approvalView ? <div style={{ paddingLeft: '10px' }}>Review Campaign</div> : <div style={{ paddingLeft: '10px' }}>View Campaign</div>,
      width: 200, // Fixed width
      renderCell: (params) => buttonGenerator(params.row),
    },
    {
      field: 'status',
      headerName: <div style={{ paddingLeft: '10px' }}>Status</div>,
      width: 120, // Fixed width
    },
    {
      field: "details",
      headerName: <div style={{ display: "flex", alignItems: "center", paddingLeft: '10px' }}>Details</div>,
      width: 100, // Fixed width
      sortable: false,
      headerClassName: "center-header", // Center-align header
      cellClassName: "left-cell", // Center-align cell values
      renderCell: (params) => (
        <img
          onClick={() => handleOpen(params.row)}
          style={{ width: "15px", cursor: "pointer" }}
          src={process.env.PUBLIC_URL + "/Images/desc_icon.png"}
        ></img>
      ),
    },
  ];


  const apiRef = useGridApiRef();



  if (approvalView) {
    columns.push({ field: 'requestorId', headerName: 'Requestor Id', minWidth: 180, maxWidth: 250 });
  }


  return (<>
    {currCampaign ?
      <div>
        <button onClick={handleBackClick} className='back-btn'>
          <img src="/Images/ApprovalPage/backbutton.png" style={{ width: "60px" }} />
        </button>
        <Campaign campaignMetaData={currCampaign} approvalView={approvalView} />
      </div>
      :
      <div className="datagrid-campaign-container"
        style={{ height: 400, width: '100%' }}>
        <DataGrid
          apiRef={apiRef}
          rows={displayHelper(campaigns)}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10]}
          showCellBorders
          disableSelectionOnClick
          disableColumnMenu
          disableExtendRowFullWidth={true}
          style={{ overflowX: 'auto' }}
          sortModel={sortModelNew}
          onSortModelChange={handleSortModelChange}
          sortingOrder={['asc', 'desc']}
          sx={{
            "& .MuiDataGrid-columnHeader": {
              backgroundColor: "#022278", // Customize the header background color
              color: "white", // Customize text color
            },
            "& .MuiDataGrid-root": {
              width: "100%", // Ensure DataGrid spans the full width
            },
            "& .MuiDataGrid-sortIcon": {
              color: "#fff", // Customize the sorter (sort icon) color
            },
            "& .MuiDataGrid-columnHeader": {
              position: "sticky",
              top: 0,
              backgroundColor: "#022278", // Optional: to ensure it’s visible on scroll
              color: "#fff",
            },
            "& .MuiDataGrid-columnHeaders": {
              width: "var(--DataGrid-rowWidth)",
            },
            "& .MuiDataGrid-row": {
              backgroundColor: "white",
              width: "calc(100% - 2px)",
            },
            "& ..MuiDataGrid-topContainer": {
              width: "700px !important",
            },
          }}
          slots={{ toolbar: GridToolbarQuickFilter }}

        // disableColumnFilter
        // disableColumnSelector
        // disableDensitySelector
        // slots={{ toolbar: QuickSearchToolbar }}
        // slotProps={{
        //   toolbar: {
        //     showQuickFilter: true,
        //   },
        // }}

        />

        <Modal
          hideBackdrop
          open={openModal}
          onClose={handleClose}
          aria-labelledby="child-modal-title"
          closeAfterTransition
          aria-describedby="child-modal-description"
          className="modal-container"
        >
          <Box className="model">
            <div className="model_heading">
              <h5 className="paramodel">Details</h5>
              <span
                className="close_btn_model"
                onClick={handleClose}
                tabIndex={0}
              >
                Close
              </span>
            </div>
            <hr />
            <div className="program-modal-details">
              <div className="program-details-wrap">
                <p className="program-details-header">Type: </p>
                <p className="program-details-value">
                  {modalRecord?.type}
                </p>
              </div>
              <div className="program-details-wrap">
                <p className="program-details-header">Market/Track:
                  {approvalView &&
                    <button onClick={() => { setMarketEditable(true); setMarketName(modalRecord?.market) }}
                      style={{
                        backgroundColor: "white", border: "1px solid #8a2be2", margin: "2px",
                        borderRadius: '50%', cursor: "pointer"
                      }}>
                      <ModeEditOutlineOutlinedIcon
                        style={{ height: "13px", width: "13px", margin: "2px 2px -1px 2px" }}
                      />
                    </button>
                  }
                </p>
                {marketEditable ?
                  <form onSubmit={(e) => handleMNSubmit(e, modalRecord?.id)}>
                    <FormControl
                      required
                      sx={{ width: 150, fontSize: "14px", padding: 0 }}
                    >
                      <Select
                        id="market-select"
                        value={newMarketName}
                        onChange={(e) => setMarketName(e.target.value)}
                        sx={{
                          fontSize: '14px',
                          '.MuiSelect-select': {
                            padding: '4px 8px', // applies to the selected area
                            fontSize: '14px',
                          },
                        }}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              fontSize: '14px',
                            },
                          },
                        }}
                      >
                        {marketOrTrackList.map((group, index) => [
                          <ListSubheader
                            key={`group-${index}`}
                            sx={{ fontSize: "13px", padding: "4px 8px" }}
                          >
                            {group.group}
                          </ListSubheader>,
                          group.sub_list.map((item, subIndex) => (
                            <MenuItem
                              key={`item-${index}-${subIndex}`}
                              value={item}
                              sx={{ fontSize: "14px", padding: "4px 8px" }}
                            >
                              {item}
                            </MenuItem>
                          ))
                        ])}
                      </Select>
                    </FormControl>

                    <button
                      type="submit"
                      style={{
                        backgroundColor: "#8a2be2",
                        color: "white",
                        padding: "2px 5px",
                        margin: "1px 3px",
                        border: "2px solid #8a2be2",
                        cursor: "pointer",
                        fontSize: "12px",
                        borderRadius: "15px",
                        fontWeight: "bold"
                      }}
                    >
                      Save
                    </button>

                    <button
                      type="button"
                      onClick={() => {
                        setMarketEditable(false);
                        setMarketName("");
                      }}
                      style={{
                        backgroundColor: "transparent",
                        padding: "2px 5px",
                        margin: "1px 3px",
                        border: "2px solid #8a2be2",
                        cursor: "pointer",
                        color: "#5B5B5B",
                        fontSize: "12px",
                        borderRadius: "15px",
                        fontWeight: "bold"
                      }}
                    >
                      Cancel
                    </button>
                  </form> :
                  <p className="program-details-value">
                    {modalRecord?.market}
                  </p>
                }
              </div>
              <div className="program-details-wrap">
                <p className="program-details-header">Target Audience: </p>
                <p className="program-details-value">
                  {modalRecord?.target_audience}
                </p>
              </div>
              <div className="program-details-wrap">
                <p className="program-details-header">People Targeted: </p>
                <p className="program-details-value">
                  {modalRecord?.people_targeted}
                </p>
              </div>
              <div className="program-details-wrap">
                <p className="program-details-header">
                  First Submitted On:{" "}
                </p>
                <p className="program-details-value">
                  {modalRecord?.submitted_for_review ? convertToDateString(modalRecord?.submitted_for_review) : "Not yet Submitted"}
                </p>
              </div>
              <div className="program-details-wrap">
                <p className="program-details-header">
                  First Approved On: {" "}
                </p>
                <p className="program-details-value">
                  {modalRecord?.first_approvedOn ? convertToDateString(modalRecord?.first_approvedOn) : "Not yet Approved"}
                </p>
              </div>
              <div className="program-details-wrap">
                <p className="program-details-header">
                  On Behalf of: {" "}
                </p>
                <p className="program-details-value" style={{ textTransform: "none" }}>
                  {modalRecord?.onBehalf_of}
                </p>
              </div>
              <div className="program-details-wrap">
                <p className="program-details-header">
                  Approved Count:{" "}
                </p>
                <p className="program-details-value">
                  {modalRecord?.approvalCount}
                </p>
              </div>
            </div>
          </Box>
        </Modal>
      </div>

    }
  </>
  );
};

export default CampaignsTable;
